import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CodeTag = styled.code`
  display: inline-block;
  padding: ${Spacing.S4} ${Spacing.S8};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R8};
  background-color: ${Color.Grey100};
  font-family: monospace;
  cursor: pointer;
`
